<template>
  <com-page>
    <com-card>
      <dateSelect @on-date="handleData" @on-export="handleExport"></dateSelect>
    </com-card>
    <com-card class="mt-15px">
      <com-table ref="table" :columns="columns" :api="api"></com-table>
    </com-card>
  </com-page>
</template>

<script>
import { exportExcel } from '@/utils'
import { rechargeOrderStatistics } from '@/api/statistics'
import dateSelect from './components/the-time-select'

export default {
  components: { dateSelect },
  data() {
    return {
      api: rechargeOrderStatistics,
      columns: [
        {
          label: '日期',
          prop: 'date'
        },
        {
          label: '充值订单数',
          prop: 'rechargeOrder'
        },
        {
          label: '用户提现订单数',
          prop: 'userWithdrawOrder'
        },
        {
          label: '充值金额',
          prop: 'rechargeAmount'
        },
        {
          label: '用户提现金额',
          prop: 'userWithdrawAmount'
        }
      ],
      query: {}
    }
  },
  methods: {
    handleData(val) {
      this.query = val
      this.$refs.table.search(val)
    },
    async handleExport() {
      try {
        this.$message.info('正在导出请稍后')
        const query = {
          ...this.query,
          pageIndex: 1,
          pageSize: 10000
        }
        const {
          data: { records }
        } = await rechargeOrderStatistics(query)
        console.log('data :>> ', records)
        const newArr = []
        records.forEach((item) => {
          const param = {
            日期: item.date,
            充值订单数: item.rechargeOrder,
            用户提现订单数: item.userWithdrawOrder,
            充值金额: item.rechargeAmount,
            用户提现金额: item.userWithdrawAmount
          }
          newArr.push(param)
        })
        exportExcel(newArr, '充值订单分析')
      } catch (err) {
        console.log('err :>> ', err)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
